module.exports = __webpack_public_path__ + "img/稿定设计-6.70fe6f98.jpg";